import * as React from "react";
import { useState, useEffect } from "react";
import Modal from "@mui/joy/Modal";
import { MdClose } from "react-icons/md";
import Sheet from "@mui/joy/Sheet";
import axios from "axios";
import { base_url } from "../../../utils/AxiosConfig";
import { format } from "date-fns";
import CircularProgress from "@mui/joy/CircularProgress";
import user1 from "../../../images/ic_no_person_photo.svg";
import { base_url_image_view_api } from "../../../utils/ImageViewingAPI";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import SnackbarNotification from "../../../utils/SnackbarNotification";

export default function ViewTimeSheetPopup(props) {
  const {
    popUpData,
    setpopUpData,
    openViewModal,
    setOpenViewModal,
    mainStartDate,
    mainEndDate,
  } = props;

  const [isCallingAPI, setIsCallingAPI] = useState(false);
  const [timeSheetArray, setTimeSheetArray] = useState(null);
  const [editableData, setEditableData] = useState([]);
  const [editedRows, setEditedRows] = useState({});

  const [timeSheetData, setTimeSheetData] = useState({
    startDate: mainStartDate || format(new Date(new Date().setDate(1)), "yyyy-MM-dd"),
    endDate: mainEndDate || format(new Date(), "yyyy-MM-dd"),
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const showSnackbar = (severity, message) =>
    setSnackbar({ open: true, severity, message });

  const handleCloseSnackbar = () =>
    setSnackbar({ ...snackbar, open: false });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTimeSheetData((prev) => ({ ...prev, [name]: value }));
  };

  const getTimeSheet = async () => {
    setIsCallingAPI(true);
    try {
      const apiUrl = `${base_url}/api/TimesheetList/CUBIX/${popUpData?.EmpId}/${timeSheetData.startDate}/${timeSheetData.endDate}`;
      const response = await axios.get(apiUrl);
      const data = response.data || [];
      setTimeSheetArray(data);
      setEditableData(
        data.map((row) => ({
          ...row,
          nr_hrs: row.nr_hrs ?? "0",
          nr_rate: row.nr_rate ?? "0",
          ot_hrs: row.ot_hrs ?? "0",
          ot_rate: row.ot_rate ?? "0",
          ots_hrs: row.ots_hrs ?? "0",
          ots_rate: row.ots_rate ?? "0",
          remarks: row.remarks ?? "",
        })),
      );
      setEditedRows({});
    } catch (err) {
      console.error("Error fetching timesheet:", err);
    } finally {
      setIsCallingAPI(false);
    }
  };

  useEffect(() => {
    if (openViewModal) getTimeSheet();
  }, [openViewModal]);

  const handleCellEdit = (index, field, value) => {
    setEditableData((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
    setEditedRows((prev) => ({ ...prev, [index]: true }));
  };

  const fetchProfilePic = (ImagePath) => {
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop();
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  const handleUpdateTimesheet = async () => {
    if (!editableData?.length) {
      showSnackbar("warning", "No records to update");
      return;
    }
    setIsCallingAPI(true);
    try {
      const payload = editableData.map((row) => ({
        mode: "ENTRY",
        cmpcode: "CUBIX",
        Empid: popUpData?.EmpId,
        StartDate: timeSheetData.startDate,
        EndDate: timeSheetData.endDate,
        deptno: "-",
        jobcode: "-",
        slno: row.isNew ? 0 : row.slno,
        Date: row.Date || "",
        type: row.type || "",
        nr_hrs: row.nr_hrs || "0",
        nr_rate: row.nr_rate || "0",
        ot_hrs: row.ot_hrs || "0",
        ot_rate: row.ot_rate || "0",
        ots_hrs: row.ots_hrs || "0",
        ots_rate: row.ots_rate || "0",
        remarks: row.remarks || "",
      }));
      await axios.post(`${base_url}/api/TimesheetReg`, payload, {
        headers: { "Content-Type": "application/json" },
      });
      showSnackbar("success", "Timesheet updated successfully");
      setEditedRows({});
      getTimeSheet();
    } catch (err) {
      showSnackbar("error", "Failed to update timesheet");
    } finally {
      setIsCallingAPI(false);
    }
  };

  const handleMarkAllAbsent = () => {
    setEditableData((prev) =>
      prev.map((row) => ({
        ...row,
        nr_hrs: "0",
        ot_hrs: "0",
        ots_hrs: "0",
        type: "A",
      })),
    );
    const allIndices = {};
    editableData.forEach((_, i) => {
      allIndices[i] = true;
    });
    setEditedRows(allIndices);
    showSnackbar("success", "All rows marked as absent (0 hrs)");
  };

  const handleExport = () => {
    const exportData = editableData.map((row, i) => ({
      "Sl No": i + 1,
      Date: dayjs(row.Date).format("DD-MMM-YYYY"),
      "Entry Date": dayjs(row.entry_date).format("DD-MMM-YYYY"),
      "Nr Hrs": row.nr_hrs,
      "Nr Rate": row.nr_rate,
      "Ot Hrs": row.ot_hrs,
      "Ot Rate": row.ot_rate,
      "Ots Hrs": row.ots_hrs,
      "Ots Rate": row.ots_rate,
      "Total Wage": row.tot_wage,
      Remarks: row.remarks || "",
      Type: row.type || "",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Timesheet");
    XLSX.writeFile(
      wb,
      `Timesheet_${popUpData?.EmpId}_${timeSheetData.startDate}_to_${timeSheetData.endDate}.xlsx`,
    );
    showSnackbar("success", "Exported successfully");
  };

  return (
    <Modal
      open={openViewModal}
      onClose={() => {
        setOpenViewModal(false);
        setpopUpData(null);
      }}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Sheet
        variant="outlined"
        className="relative w-[85vw] bg-white rounded-xl shadow-2xl overflow-hidden"
      >
        <button
          onClick={() => setOpenViewModal(false)}
          className="absolute right-4 top-4 z-10 rounded-full p-1 hover:bg-red-400 transition"
        >
          <MdClose className="w-5 h-5 text-white" />
        </button>

        <div className="p-3 bg-[#2663EB]">
          <h2 className="text-xl font-semibold text-white">
            View / Edit Timesheet
          </h2>
        </div>

        <div className="p-6 space-y-6">
          {/* Header */}
          <div className="flex flex-col sm:flex-row gap-6 items-start sm:items-end justify-between">
            <div className="flex items-center gap-4">
              <div className="shrink-0">
                {popUpData?.imagepath ? (
                  <img
                    src={fetchProfilePic(popUpData.imagepath)}
                    alt={popUpData?.Name}
                    className="w-20 h-20 rounded-full object-cover border-2 border-gray-100 shadow-sm"
                  />
                ) : (
                  <img
                    src={user1}
                    alt="Default avatar"
                    className="w-20 h-20 rounded-full object-cover border-2 border-gray-100 shadow-sm"
                  />
                )}
              </div>
              <div>
                <div className="font-medium text-gray-900 text-lg">
                  {popUpData?.Name}
                </div>
                <div className="text-sm text-gray-600">{popUpData?.EmpId}</div>
                <div className="text-sm text-gray-500 mt-0.5">
                  {popUpData?.JobTitle}
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-end gap-3 p-4  w-full sm:w-auto">
              <div className="flex gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Start Date
                  </label>
                  <input
                    type="date"
                    name="startDate"
                    value={timeSheetData.startDate}
                    onChange={handleChange}
                    max={new Date().toISOString().split("T")[0]}
                    className="w-36 px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-500 outline-none"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    End Date
                  </label>
                  <input
                    type="date"
                    name="endDate"
                    value={timeSheetData.endDate}
                    onChange={handleChange}
                    max={new Date().toISOString().split("T")[0]}
                    className="w-36 px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-500 outline-none"
                  />
                </div>
              </div>
              <button
                onClick={getTimeSheet}
                className="px-5 py-2 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition-colors shadow-sm whitespace-nowrap"
              >
                View
              </button>
              <button
              onClick={handleMarkAllAbsent}
              className="px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-lg transition-colors shadow-sm text-sm"
            >
              Mark All as Absent
            </button>
            <button
              onClick={handleExport}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors shadow-sm text-sm"
            >
              Export to Excel
            </button>
            <button
              onClick={handleUpdateTimesheet}
              disabled={isCallingAPI || Object.keys(editedRows).length === 0}
              className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-400 text-white font-medium rounded-lg transition-colors shadow-sm text-sm"
            >
              {isCallingAPI ? "Updating..." : "Update Timesheet"}
            </button>
            </div>
          </div>


          {/* Table */}
          {isCallingAPI ? (
            <div className="flex justify-center py-12">
              <CircularProgress size="lg" />
            </div>
          ) : (
            <div className="max-h-[400px] overflow-auto rounded-lg border border-gray-200">
              <table className="w-full text-sm text-left text-gray-700">
                <thead className="bg-[#2663EB] text-white uppercase tracking-wide text-xs sticky top-0">
                  <tr>
                    <th className="px-4 py-3 font-medium">Sl No.</th>
                    <th className="px-4 py-3 font-medium">Date</th>
                    <th className="px-4 py-3 font-medium">Type</th>
                    <th className="px-4 py-3 font-medium">Nr Hrs</th>
                    <th className="px-4 py-3 font-medium">Nr Rate</th>
                    <th className="px-4 py-3 font-medium">Ot Hrs</th>
                    <th className="px-4 py-3 font-medium">Ot Rate</th>
                    <th className="px-4 py-3 font-medium">Ots Hrs</th>
                    <th className="px-4 py-3 font-medium">Ots Rate</th>
                    <th className="px-4 py-3 font-medium">Tot Wage</th>
                    <th className="px-4 py-3 font-medium">Remarks</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {editableData?.map((item, idx) => (
                    <tr
                      key={item.slno || idx}
                      className={`hover:bg-gray-50/70 transition-colors ${
                        editedRows[idx] ? "bg-yellow-50" : ""
                      }`}
                    >
                      <td className="px-4 py-3">{item.slno}</td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        <input
                          type="date"
                          value={item.Date ? dayjs(item.Date).format("YYYY-MM-DD") : ""}
                          onChange={(e) =>
                            handleCellEdit(idx, "Date", e.target.value)
                          }
                          className="w-36 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-indigo-300 outline-none"
                        />
                      </td>
                      <td className="px-4 py-3">
                        <input
                          type="text"
                          value={item.type || ""}
                          onChange={(e) =>
                            handleCellEdit(idx, "type", e.target.value)
                          }
                          className="w-24 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-indigo-300 outline-none"
                        />
                      </td>
                      <td className="px-4 py-3">
                        <input
                          type="number"
                          step="any"
                          value={item.nr_hrs}
                          onChange={(e) =>
                            handleCellEdit(idx, "nr_hrs", e.target.value)
                          }
                          className="w-16 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-indigo-300 outline-none"
                        />
                      </td>
                      <td className="px-4 py-3 text-gray-600">{item.nr_rate}</td>
                      <td className="px-4 py-3">
                        <input
                          type="number"
                          step="any"
                          value={item.ot_hrs}
                          onChange={(e) =>
                            handleCellEdit(idx, "ot_hrs", e.target.value)
                          }
                          className="w-16 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-indigo-300 outline-none"
                        />
                      </td>
                      <td className="px-4 py-3 text-gray-600">{item.ot_rate}</td>
                      <td className="px-4 py-3">
                        <input
                          type="number"
                          step="any"
                          value={item.ots_hrs}
                          onChange={(e) =>
                            handleCellEdit(idx, "ots_hrs", e.target.value)
                          }
                          className="w-16 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-indigo-300 outline-none"
                        />
                      </td>
                      <td className="px-4 py-3 text-gray-600">{item.ots_rate}</td>
                      <td className="px-4 py-3 font-medium">{item.tot_wage}</td>
                      <td className="px-4 py-3">
                        <input
                          type="text"
                          value={item.remarks || ""}
                          onChange={(e) =>
                            handleCellEdit(idx, "remarks", e.target.value)
                          }
                          className="w-28 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-indigo-300 outline-none"
                        />
                      </td>
                      
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="flex justify-start px-1 py-2">
                <button
                  onClick={() => {
                    const newRow = {
                      isNew: true,
                      slno: (editableData?.length || 0) + 1,
                      Date: new Date().toISOString().split("T")[0],
                      entry_date: new Date().toISOString().split("T")[0],
                      nr_hrs: "0",
                      nr_rate: "0",
                      ot_hrs: "0",
                      ot_rate: "0",
                      ots_hrs: "0",
                      ots_rate: "0",
                      tot_wage: "0",
                      remarks: "",
                      type: "",
                    };
                    setEditableData((prev) => [...(prev || []), newRow]);
                    setEditedRows((prev) => ({
                      ...prev,
                      [editableData?.length || 0]: true,
                    }));
                  }}
                  className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition-colors shadow-sm text-sm"
                >
                  + Add Row
                </button>
              </div>

              {!timeSheetArray?.length && (
                <div className="py-10 text-center text-gray-500">
                  No timesheet entries found for the selected period.
                </div>
              )}
            </div>
          )}
        </div>

        <SnackbarNotification
          open={snackbar.open}
          severity={snackbar.severity}
          message={snackbar.message}
          onClose={handleCloseSnackbar}
        />
      </Sheet>
    </Modal>
  );
}
